import React from 'react';
import { Link } from 'react-router-dom';
import './feature-block.css';

interface FeatureBlockProps {
  title: string;
  body: string;
  titleLink?: string;
}

const FeatureBlock = ({ title, body, titleLink }: FeatureBlockProps) => {
  const explorePageLink = './explore';
  const LinkTag = () => {
    if (!titleLink) {
      return;
    }
    return (
      <Link className="explore-link" to={explorePageLink}>
        {titleLink}
      </Link>
    );
  };

  return (
    <div className="feature-block">
      <h3 className="feature-title">
        {title} {LinkTag()}
      </h3>
      <p className="feature-body">{body}</p>
    </div>
  );
};

export default FeatureBlock;
